var modules_640a77b2 = {"container":"_1rpu86k","calendar-wrapper":"_1rwy8l3"};
import "../../../assets/KCeN3DUq.css";

export { modules_640a77b2 as default };
//# sourceMappingURL=DateInput.module.less.js.map
